import { useMemo } from "react";
import type { PlanningFilters } from "@landtechnologies/search-layer-contracts";
import { createPlanningApplicationLayerFilters } from "react-migration/domains/planning/map/layers/PlanningApplicationGeoJsonLayer/planningFilters";
import { planningTypes } from "react-migration/domains/planning/constants";
import type { ClassAndTypeFilters, PlanningTypesFilters } from "react-migration/domains/planning/types";

export function useClassAndTypeFilters(filters: PlanningFilters) {
  const { showCommercial, enabledTypes, enabledStatuses, minSize, showOther, showResidential, showAppealed, maxYear } =
    filters;

  return useMemo(() => {
    const filters: ClassAndTypeFilters = {
      showCommercial,
      showResidential,
      showOther,
      minSize,
      maxYear,
      showAppealed,
      planningTypes: Object.fromEntries(
        planningTypes.map((planningType) => [planningType.id, enabledTypes.includes(planningType.id)])
      ) as PlanningTypesFilters,
      // TODO: Investigate how to control these
      showMinor: true,
      visiblePlanningApplicationIds: [],
      enabledStatuses,
      appToHide: "",
    };

    return [filters, createPlanningApplicationLayerFilters(filters)] as const;
  }, [showCommercial, enabledTypes, minSize, showOther, showResidential, maxYear, enabledStatuses, showAppealed]);
}
